import React, { useState, useEffect } from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

const SliderSection = ({
  sliderImages = [],
  height = '90vh',
  autoSlide = true,
  intervalTime = 5000
}) => {
  const [current, setCurrent] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const nextSlide = () => {
    setCurrent((prev) => (prev === sliderImages.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev === 0 ? sliderImages.length - 1 : prev - 1));
  };

  // Detect screen size
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Auto-slide
  useEffect(() => {
    if (!autoSlide || isMobile) return;
    const interval = setInterval(nextSlide, intervalTime);
    return () => clearInterval(interval);
  }, [current, autoSlide, intervalTime, isMobile]);

  return (
    <section>
      <div className="relative w-full overflow-hidden" style={{ height }}>
        {sliderImages.map((slide, index) => (
       <img
       key={index}
       src={slide.src}
       alt={`Slide ${index}`}
       className={`absolute top-0 left-0 w-full h-full object-cover transition-all duration-[4000ms] ease-in-out transform ${
         index === current ? 'scale-105 opacity-100 z-10' : 'scale-100 opacity-0 z-0'
       }`}
     />
        ))}

        {/* Overlay Content */}
        <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center z-20 px-4">
          <p className="text-sm sm:text-lg md:text-2xl text-yellow-300 font-cursive">
            {sliderImages[current]?.subheading}
          </p>
          <h1 className="text-2xl sm:text-4xl md:text-6xl font-bold drop-shadow-lg">
            {sliderImages[current]?.heading}
          </h1>
          {/* <button className="mt-6 sm:mt-8 w-16 sm:w-20 h-16 sm:h-20 rounded-full bg-white text-black flex items-center justify-center text-xs sm:text-sm font-medium shadow-lg hover:bg-gray-200 transition">
            <span className="mr-1">Explore</span>
            <FaArrowRight />
          </button> */}
        </div>

        {/* Arrows */}
        {!isMobile && (
          <>
            <button
              onClick={prevSlide}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 z-30 text-white text-xl sm:text-2xl"
            >
              <FaArrowLeft />
            </button>
            <button
              onClick={nextSlide}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 z-30 text-white text-xl sm:text-2xl"
            >
              <FaArrowRight />
            </button>
          </>
        )}

        {/* Dots */}
        <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 z-30 flex space-x-2">
          {sliderImages.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrent(index)}
              className={`w-3 h-3 rounded-full ${
                index === current ? 'bg-white' : 'bg-white/50'
              } transition-all duration-300`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SliderSection;